import { Theme } from '@material-ui/core/styles';

export default (theme: Theme) => [
  theme.colors.lightTeal[200],
  theme.colors.indigo[900],
  theme.colors.teal[400],
  theme.colors.indigo[400],
];
